
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activation",
      function () {
        return require("private-next-pages/activation.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activation"])
      });
    }
  